module.exports = __webpack_public_path__ + "img/icon_grid_downn.b4745cf2.svg";